<template>
    <div>
        <van-action-sheet
                title="选品清单"
                v-model="showSelect"
                style="min-height: 95%"
                @close="selectListClose"
        >
            <div>
                <div>
                    <Row type="flex" justify="start" style="padding: 10px;">
                        <i-col span="19">
                        </i-col>
                        <i-col span="5" style="text-align: center">
                            <van-button
                                    size="small"
                                    type="danger"
                                    @click="removeAllSelectSku"
                            >全部移除
                            </van-button>
                        </i-col>
                    </Row>

                </div>
                <div v-for="(item, index) in JdSelectListMark.select_skuInfo_list" v-bind:key="index">
                    <Row type="flex" justify="start" style="padding: 10px;">
                        <i-col span="4" style="height: 60px; line-height: 60px; text-align: center">
                            <Wp_image :url="item.imageInfo.imageList[0].url"></Wp_image>
                            <!--                                <div>{{item.skuId}}</div>-->
                        </i-col>
                        <i-col span="15">
                            <div class="select_skuName_div">{{item.skuName}}</div>
                        </i-col>
                        <i-col span="5" style="height: 60px; line-height: 60px; text-align: center">
                            <!--                            <div style="text-align: center; background-color: #D70C12; "><van-icon name="close" size="20px"/></div>-->
                            <van-button
                                    size="small"
                                    color="orange"
                                    @click="removeSelectSku(index)"
                            >移除
                            </van-button>
                        </i-col>
                    </Row>

                </div>

                <div style="text-align: center;margin-top: 15px; position: sticky; bottom: 0; background-color: white; padding-bottom: 25px; ">
                    <van-button
                                type="info"
                                style="width: 90%;margin-top: 10px"
                                :disabled="is_make_button_disable"
                                @click="makeContent"
                    >生成文案
                    </van-button>
                    <div style="margin-top: 10px; margin-left: 10px; margin-right: 10px; text-align: left">
                        <div v-if="show_loading === 1">
                            <Alert :type="alert_type">
                                <van-loading size="17px" color="#1989fa">
                                    <span style="font-size: 12px; color: #1989fa">{{loading_text}}</span>
                                </van-loading>
                            </Alert>
                        </div>
                        <div v-else-if="show_loading === 2">
                            <Alert :type="alert_type">
                                <div style="">
                                    {{loading_text}}
                                </div>
                            </Alert>
                        </div>
                    </div>

                </div>
            </div>
        </van-action-sheet>


        <van-action-sheet
                title="分享商品集"
                v-model="showSelectLink"
                @close="sheetClosed"
                style="padding-bottom: 50px; min-height: 90%"
        >

            <div style="padding: 20px">
                <Alert type="warning">转发步骤:1.长按保存图片,2.点击复制文案。</Alert>
                <div style="text-align: center; margin-top: 10px; margin-bottom: 10px;">
                    <div v-if="image_splice_list && image_splice_list.length === 1">

                        <Wp_image :url="image_splice_list[0]" :width="'50'"></Wp_image>
                    </div>
                    <div v-else-if="image_splice_list && image_splice_list.length > 1">
                        <Wp_image_splice
                                :img_list="image_splice_list"
                                :max-width="600"
                                :max-height="600">
                        </Wp_image_splice>
                    </div>
                </div>

                <div>
                    <van-field
                            v-model="linkContent"
                            type="textarea"
                            rows="10"
                            :autosize="{maxHeight: 280, minHeight: 100}"
                            style="border: 1px solid #77FFCC55; border-radius: 4px; padding: 10px; background-color: #77FFCC22"
                    ></van-field>
                </div>
            </div>
            <div style="text-align: center">
                <van-sticky :offset-top="50" style="position: fixed;bottom: 0px;text-align: center; width: 100%; padding: 10px;
                                background-color: #ffffff; box-shadow: 1px -1px 3px #999999">
                    <van-button v-if="newLink"

                                type="info"

                                style="width: 90%; margin-bottom: 10px"
                                v-clipboard:copy="linkContent.replace(new RegExp('<br/>','gm'),'\n')"
                                v-clipboard:success="onCopySuccess"
                                v-clipboard:error="onError"
                    >复制文案
                    </van-button>
                </van-sticky>
            </div>

            <van-button id="stamp_button" ref="stamp_button" type="danger" plain
                        style="width: auto; height: auto; z-index:1;border-radius: 3px;
                        padding-left: 5px; padding-right:5px; padding-top: 5px; padding-bottom: 5px;
                        display: none;position: absolute;right:10%;bottom:42%; background-color: #ffffff77;
                        transform: rotate(25deg)"
            >
                <van-button type="danger" plain hairline
                            style="width:100%; height: 100%;border-radius: 3px;background-color: #ffffff77; "
                ><h3>复制成功</h3>
                </van-button>
            </van-button>


        </van-action-sheet>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Row, Col, Alert} from 'iview';
    import Wp_image from "./Wp_image";
    import Wp_image_splice from "./Wp_image_splice";

    Vue.component('Row', Row);
    Vue.component('i-col', Col);
    Vue.component('Alert', Alert);

    export default {
        name: "JdSelectListSheet",
        components: {Wp_image_splice, Wp_image},
        inject: ['JdSelectListMark'],

        data() {
            return {
                //选品清单sheet是否弹出
                showSelect: false,
                //选品清单生成模板内容的sheet是否弹出
                showSelectLink: false,

                //选品清单中每个商品的第一张图片的集合
                imageMap: null,
                //拼图组件所需的图片list集合
                image_splice_list: [],
                //选品清单中每个商品转链后的文字内容集合(Map)
                contentMap: null,
                //链接及文字等组合的文案内容
                linkContent: "",
                //转链后的新链接
                newLink: "",
                //存储文案生成失败的信息
                fail_skuName_list: [],

                copySuccess: false,

                //清单列表中生成文案按钮的可用状态
                is_make_button_disable: false,
                //alert的type
                alert_type: '',
                show_loading: 0,
                loading_text: '',

                select_skuId_list_temp:[],
            }
        },

        methods: {
            /**
             * 清除选品清单列表中的所有商品
             */
            removeAllSelectSku() {
                this.JdSelectListMark.select_skuInfo_list = [];
                this.JdSelectListMark.select_skuId_list = [];

                this.show_loading = 0;
                this.is_make_button_disable = true;
                setTimeout(()=>{
                    this.showSelect = false;
                }, 200);
            },

            /**
             * 清除选品清单列表中的某一个商品
             */
            removeSelectSku(index) {
                this.JdSelectListMark.select_skuInfo_list.splice(index, 1);
                this.JdSelectListMark.select_skuId_list.splice(index, 1);

                if (this.JdSelectListMark.select_skuInfo_list.length === 0) {
                    this.is_make_button_disable = true;
                }
            },

            /**
             * 生成文案
             */
            makeContent() {
                this.alert_type = 'info';
                this.show_loading = 1;
                this.loading_text = '清单模板生成中，请稍后';

                this.is_make_button_disable = true;

                this.getSelectSkuList();
            },

            getSelectSkuList() {

                if (this.JdSelectListMark.select_skuInfo_list && this.JdSelectListMark.select_skuInfo_list.length > 0) {
                    for (let i = 0; i < this.JdSelectListMark.select_skuInfo_list.length; i++) {

                        //转链并存储文字内容
                        this.makeLinks(this.JdSelectListMark.select_skuInfo_list[i], this.findCoupon(this.JdSelectListMark.select_skuInfo_list[i]));
                    }
                }


                // let value = "";
                // if(this.select_skuId_list && this.select_skuId_list.length > 0){
                //     for(let i = 0; i < this.select_skuId_list.length; i++){
                //         value += this.select_skuId_list[i] + ",";
                //     }
                //     if(value){
                //         value = value.substring(0, value.length-1);
                //     }
                // }
                // if(value){
                //     let params = {
                //         sku_list: value
                //     };
                //
                //     this.$getSelectSkuList(params, response => {
                //         if(response){
                //             this.select_skuInfo_list = response.data;
                //
                //             if(this.select_skuInfo_list && this.select_skuInfo_list.length > 0){
                //                 for(let i = 0; i < this.select_skuInfo_list.length; i++){
                //
                //                     //存储选品集合商品的第一张图片
                //                     this.imageList.push(this.select_skuInfo_list[i].imageInfo.imageList[0].url);
                //
                //                     //转链并存储文字内容
                //                     this.makeLinks(this.select_skuInfo_list[i], this.findCoupon(this.select_skuInfo_list[i]), i);
                //                 }
                //             }
                //
                //
                //         }
                //     })
                // }
            },

            /**
             * 查找优惠券
             */
            findCoupon(skuInfo) {
                let couponList = skuInfo.couponInfo.couponList;
                let _couponData = this.$common.autoFindCoupon2(couponList);
                if (_couponData) {
                    return _couponData;
                }
                return null;
            },

            makeLinks(skuInfo, couponData) {
                let _skuId = skuInfo.skuId;
                if (_skuId) {
                    let _materialId = 'https://wqitem.jd.com/item/view?sku=' + _skuId;
                    let _couponUrl = '';
                    if(couponData && couponData.discount && typeof (couponData.discount) !== 'undefined' && skuInfo.priceInfo.lowestCouponPrice){
                        _couponUrl = couponData.link;
                    }
                    let _positionId = this.$common.getPid();
                    // let _positionId = '1825325610';
                    let _data = {
                        app_key: this.$common.getAppKeyInfo('70637').app_key,
                        app_secret: this.$common.getAppKeyInfo('70637').app_secret,
                        materialId: _materialId,
                        subUnionId: '',
                        positionId: _positionId, //推广位ID
                        // pid: _pid,
                        couponUrl: _couponUrl,
                        chainType: 2,
                    };

                    this.$getUnionLink(_data, response => {
                        let code = response.code;
                        // let message = response.message;

                        if (code === 200) {

                            //存储选品集合商品的第一张图片
                            if(!this.imageMap){
                                this.imageMap = new Map();
                            }
                            this.imageMap.set(_skuId, skuInfo.imageInfo.imageList[0].url);
                            this.select_skuId_list_temp.push(_skuId)

                            this.newLink = response.data.shortURL;

                            //存储转链后的文字信息
                            if(!this.contentMap){
                                this.contentMap = new Map();
                            }
                            this.contentMap.set(_skuId, this.getLinkContent(skuInfo, couponData, this.newLink))

                        } else if (code === 2001917) {

                            this.fail_skuName_list.push("【商品名】" + skuInfo.skuName + "\n" + "【失败信息】" + response.message + "\n\n"
                                + "");

                        } else if (code === 2001906) {
                            this.fail_skuName_list.push("【商品名】" + skuInfo.skuName + "\n" + "【失败信息】" + response.message + "\n\n"
                                + "");

                        }else{
                            this.fail_skuName_list.push("【商品名】" + skuInfo.skuName + "\n" + "【失败信息】" + response.message + "\n\n"
                                + "");
                        }

                        if (this.imageMap && (this.imageMap.size + this.fail_skuName_list.length === this.JdSelectListMark.select_skuInfo_list.length)) {

                            for(let i = 0; i < this.imageMap.size; i++){
                                this.image_splice_list.push(this.imageMap.get(this.select_skuId_list_temp[i]))
                            }



                            this.is_make_button_disable = false;

                            if (this.fail_skuName_list && this.fail_skuName_list.length > 0) {

                                this.alert_type = 'error'
                                this.show_loading = 2;
                                this.loading_text = '清单模板构建失败';

                                let skuNames = "";
                                for (let i = 0; i < this.fail_skuName_list.length; i++) {
                                    skuNames += this.fail_skuName_list[i]
                                }

                                if (this.contentMap && this.contentMap.size > 0) {
                                    skuNames += "其余选品信息模板生成完毕，点击确定查看"

                                    this.alert_type = 'warning'
                                    this.show_loading = 2;
                                    this.loading_text = '清单模板部分构建完成';
                                }

                                setTimeout(()=>{
                                    this.showSelect = false;
                                }, 1000);

                                this.$dialog.alert({
                                    title: "清单模板生成失败",
                                    messageAlign: "left",
                                    message: skuNames
                                }).then(() => {
                                    if (this.contentMap && this.contentMap.size > 0) {

                                        for(let i = 0; i < this.contentMap.size; i++){
                                            this.linkContent += this.contentMap.get(this.select_skuId_list_temp[i]);
                                        }

                                        //当最后一个数据处理完成，打开复制文案弹窗
                                        this.showSelectLink = true;
                                    } else {

                                        this.releaseSelectData();
                                    }
                                });
                            } else {
                                if (this.contentMap && this.contentMap.size > 0) {

                                    this.alert_type = 'success'
                                    this.show_loading = 2;
                                    this.loading_text = '清单模板构建完成';

                                    for(let i = 0; i < this.contentMap.size; i++){
                                        this.linkContent += this.contentMap.get(this.JdSelectListMark.select_skuId_list[i]);
                                    }

                                    //当最后一个数据处理完成，打开复制文案弹窗
                                    this.showSelectLink = true;
                                }
                            }
                        }else{
                            this.alert_type = 'error'
                            this.show_loading = 2;
                            this.loading_text = '清单模板构建失败，请联系客服人员';
                        }
                    })
                }
            },

            /**
             * 构建模板
             */
            getLinkContent(skuInfo, couponData, newLink) {
                let content = '';

                let sdk_name = skuInfo.skuName
                if (skuInfo.owner === "g") {
                    sdk_name = '【京东自营】' + sdk_name;
                }else{
                    sdk_name = '【京东】' + sdk_name;
                }

                content += sdk_name + '\n';

                if (skuInfo.goodCommentsShare) {
                    content += '好评率：' + Number(skuInfo.goodCommentsShare).toFixed(2) + '%' + '\n';
                }

                content += '京东价: ' + skuInfo.priceInfo.lowestPrice.toFixed(2) + "元" + '\n';

                if (couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice) {
                    content += '优惠券：' + couponData.discount + "元" + '\n';
                    content += '内购价: ' + (skuInfo.priceInfo.lowestCouponPrice).toFixed(2) + "元" + "🉐" + '\n';
                }

                content += '下单：' + newLink + '\n';

                content += '---------------\n';

                return content;
            },

            /**
             * 选品清单界面关闭
             */
            selectListClose() {
                this.is_make_button_disable = false;
            },

            /**
             * sheet上拉模板关闭时回调
             */
            sheetClosed() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'none';
                //删除"复制成功"图章
                this.$refs.stamp_button.style.display = 'none';

                this.releaseSelectData();

                if (this.copySuccess) {
                    //如果文案复制成功，则再sheet的关闭监听里，清楚选品清单里的数据
                    this.clearSelectSkuInfoData();
                    this.showSelect = false;

                    this.copySuccess = false;
                }
                //
                // this.showSelect = false;
            },


            releaseSelectData() {
                // this.$log("-------选品清单已生成的文案数据重置-------")
                //swipe所要加载的图片集合重置
                this.imageMap = null;

                this.select_skuId_list_temp = [];

                this.image_splice_list = [];

                this.contentMap = null;

                this.linkContent = "";

                this.fail_skuName_list = [];

            },

            clearSelectSkuInfoData() {
                this.JdSelectListMark.select_skuId_list = [];

                this.JdSelectListMark.select_skuInfo_list = [];
            },

            /**
             * 显示"复制成功"的图章
             */
            showStamp() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'block';
                //展示"复制成功"图章
                this.$refs.stamp_button.style.display = 'block';
            },

            onCopySuccess() {
                this.showStamp();

                this.copySuccess = true;

                setTimeout(() => {
                    // this.showLink = false;
                    // this.$toast.success({
                    //     message: '复制成功',
                    //     duration: 1000
                    // });
                    this.$notify({
                        message: '\n复制成功\n ',
                        duration: 2000,
                        background: '#1989fa'
                    });

                }, 500);
            },
            onError() {
                // this.$toast.error({
                //     message: '复制失败',
                //     duration: 1000
                // });
                setTimeout(() => {
                    this.$notify({
                        message: '\n复制失败\n ',
                        duration: 2000,
                    });
                }, 500);
            },
        }
    }
</script>

<style scoped>
    .select_skuName_div {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        margin-left: 10px;
    }

</style>